import React, { Component } from 'react';
import et from "../images/flux_tower.webp";
import vic from "../images/probes_network.webp";
import "./Observations.css"; // Import a separate CSS file for styling
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {  Link} from "react-router-dom";


class Observations extends Component {
  render() {
   
    return (
      <Container  className=" d-flex flex-column ">
        <Row>
          <Col>
      <Container fluid className="big-title"> 

              <h2 className="blue-text1">Hydro-Met<span className="red-text1">Observation</span>Network</h2>
            </Container></Col>
            </Row>
            <Row>
              <Col>

      
<Container fluid className="observations" >
      <Container fluid className='Observ_Container' style={{display:"flex"}}>
        <Row >

          <Col md={6} lg={6}  xs={12}  className="mb-3 mb-md-10" >
          <Link to="/et-flux-dashboard" target="_blank" rel="noopener noreferrer" >
          <div style={{ width: '100%', height: '10%',padding:"5px",textAlign:"center",textDecoration:"None", backgroundColor:"#217ca3",color:"#fff",fontWeight: "bold", fontSize:"clamp(14px, 2vw, 20px)" }}>Eddy Covariance Flux Tower Network</div>
          <img src={et} alt="Image 1" style={{ width: '100%',border:"4px solid #217ca3" }}/>
        </Link>
          </Col>

          <Col md={6} lg={6} xs={12} className="mb-3 mb-md-10" >
          <Link to="/vic-soil-moisture-dashboard" target="_blank" rel="noopener noreferrer">
          <div style={{ width: '100%', height: '10%',padding:"5px",textAlign:"center",textDecoration:"None", backgroundColor:"#217ca3",color:"#fff",fontWeight: "bold", fontSize: "clamp(14px, 2vw, 20px)"}}>Permanent Soil Moisture Probes Network</div>
          <img src={vic} alt="Image 2" style={{ width: '100%',border:"4px solid #217ca3" }}/>

        </Link>
          
          </Col>
        </Row>
      </Container>
      </Container>
      </Col>
      </Row>
      </Container>
      
    );
  }
}

export default Observations;

